import { FormControl, FormLabel, Grid, Select } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function MonthOfHalfYearField(props) {
    const { value, onChange } = props;
    const { t } = useTranslation();

    const helperText = useMemo(() => {
        switch(value) {
        case 1:
            return t('recurrence.field.monthOfHalfYear.helper1');
        case 2:
            return t('recurrence.field.monthOfHalfYear.helper2');
        case 3:
            return t('recurrence.field.monthOfHalfYear.helper3');
        case 4:
            return t('recurrence.field.monthOfHalfYear.helper4');
        case 5:
            return t('recurrence.field.monthOfHalfYear.helper5');
        case 6:
            return t('recurrence.field.monthOfHalfYear.helper6');
        default:
            return '';
        }
    }, [value, t])

    return(
        <Grid item>
            <FormLabel>{t('recurrence.field.monthOfHalfYear.label')}</FormLabel>
            <br/>
            <Grid sx={{display: 'flex'}}>
                <FormControl sx={{m: 1, minWidth: 150}}>
                    <Select value={value} onChange={onChange}>
                        <MenuItem value={1}>{t('recurrence.ordinal.first')}</MenuItem>
                        <MenuItem value={2}>{t('recurrence.ordinal.second')}</MenuItem>
                        <MenuItem value={3}>{t('recurrence.ordinal.third')}</MenuItem>
                        <MenuItem value={4}>{t('recurrence.ordinal.fourth')}</MenuItem>
                        <MenuItem value={5}>{t('recurrence.ordinal.fifth')}</MenuItem>
                        <MenuItem value={6}>{t('recurrence.ordinal.sixth')}</MenuItem>
                    </Select>
                </FormControl>
                <Typography sx={{fontStyle: 'italic', marginTop: '20px'}}>{helperText}</Typography>
            </Grid>


        </Grid>
    )
}

MonthOfHalfYearField.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
};
